import React, { useContext, useEffect, useState } from 'react';
import EntryContext from '../entry/entry-context';
import '../../index.scss'
import { Job } from '../../services/job/job.interface';
import { JobService } from '../../services/job/job.service';
import { Route, Switch } from 'react-router-dom';
import JobContent from './job-content';
import { JobType } from '../../types';

export default function JobPage() {
  const { setData, setPicklist } = useContext(EntryContext);
  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => {
    setData({});
    setPicklist([]);

    (async () => {
      const result = await new JobService().findAll();

      setJobs(result);

    })();
    const cleanup = () => {
    }
    return cleanup();

  }, []);

  return (
    <Switch>
      <Route exact path="/">
        <JobContent jobs={jobs} />
      </Route>
      <Route exact path="/job">
        <JobContent jobs={jobs} />
      </Route>
      <Route exact path="/index.html">
        <JobContent jobs={jobs} />
      </Route>
      <Route path={`/job/${JobType.MeisterShoes}`}>
        <JobContent jobs={jobs} tabIndex={0} />
      </Route>
      <Route path={`/job/${JobType.MeisterBags}`}>
        <JobContent jobs={jobs} tabIndex={1} />
      </Route>
      <Route path={`/job/${JobType.ClientAdvisor}`}>
        <JobContent jobs={jobs} tabIndex={2} />
      </Route>
      <Route path={`/job/${JobType.ITEngineer}`}>
        <JobContent jobs={jobs} tabIndex={3} />
      </Route>
    </Switch>
  );
}
